import { ref, computed } from '@vue/composition-api'
import { constants as c } from '@kingpin-global/kingpin-utils-frontend'
import store from '@/store'
import { FETCH_WISHLISTS } from '@/store/modules/shop.module'
import { sortByUpdatedAt } from '@/common-utils'

const { BRAND_ACCESS } = c

// Legacy DashboardWishlist.vue capped at 4 via splice(0, 4); preserve that as
// the default so the legacy /dashboard route keeps its original display.
// V2 callers pass a larger limit for their wider single-row layout.
const DEFAULT_WISHLIST_LIMIT = 4

export function useDashboardWishlist({ limit = DEFAULT_WISHLIST_LIMIT } = {}) {
  const wishlists = ref([])
  const isLoaded = ref(false)

  const profile = computed(() => store.state.auth.profileData)
  const isEnabledMarketplace = computed(
    () => profile.value?.access?.includes(BRAND_ACCESS.MARKETPLACE),
  )

  async function fetchWishlist() {
    try {
      // FETCH_WISHLISTS resolves to a plain wishlist array (already unwrapped by the action).
      // { force: true } always bypasses Vuex cache; the spread-copy guards against
      // sort() mutating a shared array if that ever changes.
      const result = await store.dispatch(FETCH_WISHLISTS, { force: true })
      const sorted = sortByUpdatedAt([...(result || [])]) || []
      wishlists.value = sorted.slice(0, limit)
    } catch (e) {
      // Preserve legacy silent-catch behavior
    } finally {
      isLoaded.value = true
    }
  }

  return {
    wishlists,
    isLoaded,
    profile,
    isEnabledMarketplace,
    fetchWishlist,
  }
}
